module.exports = {
  fichasData: () => {
    return{
      "IONIQ 5 EV-POWER": require("../assets/IONIQ5/ficha/FT-IONIQ-5-EV-POWER.pdf"),
      "TUCSON HEV LIMITED": require("../assets/TUCSON/ficha/FT-TUCSON-HIBRIDA.pdf"),
      "PALISADE SPORT": require("../assets/PALISADE/ficha/FT-PALISADE-SPORT.pdf"),
      "STARIA LUJO": require("../assets/STARIA/ficha/FT-STARIA-LUJO.pdf"),
      "VENUE LIMITED AT": require("../assets/VENUE/ficha/FT-VENUE.pdf"),
      "HB20 ADVANCE": require("../assets/HB20/ficha/FT-HB20-HATCHBACK.pdf"),
      "HB20S ADVANCE": require("../assets/HB20S/ficha/FT-HB20S-SEDAN.pdf"),
      "CRETA PREMIUM": require("../assets/CRETA/ficha/FT-NUEVA-CRETA.pdf"),
      "KONA HEV LIMITED": require("../assets/KONA/ficha/FT-NUEVA-KONA-HIBRIDA-HEV.pdf"),
      "SANTA FE HEV LIMITED 4x4": require("../assets/SANTAFE/ficha/FT-SANTAFE-HEV.pdf"),

      "GRAND i10 AT PREMIUM": require("../assets/GRANDi10/ficha/FT-GRAND-I10-PARTICULAR.pdf"),
      "PALISADE HEV 4x4": require("../assets/PALISADE_HEV/ficha/FT-PALISADE-HIBRIDA.pdf"),
      // "IONIQ 5 EV-POWER": "https://www.hyundaicolombia.co/fichas/reciente/FT-IONIQ-5-EV-POWER.pdf",
      // "TUCSON LIMITED": "https://www.hyundaicolombia.co/fichas/reciente/FT-TUCSON-NX4.pdf",
      // "PALISADE SPORT": "https://www.hyundaicolombia.co/fichas/reciente/FT-PALISADE-SPORT.pdf",
      // "STARIA LUJO": "https://www.hyundaicolombia.co/fichas/reciente/FT-STARIA-LUJO.pdf",
      // "VENUE LIMITED AT": "https://www.hyundaicolombia.co/fichas/reciente/FT-VENUE.pdf",
      // "HB20 ADVANCE": "https://www.hyundaicolombia.co/fichas/reciente/FT-HB20-HATCHBACK.pdf",
      // "HB20S ADVANCE": "https://www.hyundaicolombia.co/fichas/reciente/FT-HB20S-SEDAN.pdf",
      // "CRETA PREMIUM": "https://www.hyundaicolombia.co/fichas/reciente/FT-NUEVA-CRETA.pdf",
      // "KONA HEV LIMITED": "https://www.hyundaicolombia.co/fichas/reciente/FT-NUEVA-KONA-HIBRIDA-HEV.pdf",
      // "SANTA FE HEV LIMITED 4x4": "https://hyundaicolombia.co/fichas/reciente/FT-SANTAFE-HEV.pdf",
    }
  }
}